import React, { createContext, useReducer, useMemo } from 'react';
export type PriceRemoteContextValuesType = {
  isCompact: boolean;
  isDetailOpened: boolean;
  hasOpenedDetailsAtLeastOnce: boolean;
  hasShownOptionHoldAtLeastOnce: boolean;
  isInLayer: boolean;
  isJoyview: boolean;
  isOverrideSticky: boolean;

  /*
    isOverrideSticky is used ONLY to remotely disable the sticky remote in the
    case that a dropdown is opened in the Form, deeper in the components,
    we're putting this in the context only to avoid complex/tedious/fragile/whatever
    props-drilling with unclear names
    I named it `override sticky` just to make it scary sounding, a more accurate
    name would be "isDropdownOpenedSomewhereInTheComponent" which is, uh,
    UGH.
    tl;dr : you shouldn't ever need to use this at all so if you do, do it at
    your own risk
    */
  isTotalPrice: boolean;
  submitPriceRemoteForm: (arg0: Event | null | undefined) => void;
};
const initialState = {
  isCompact: false,
  isDetailOpened: false,
  hasOpenedDetailsAtLeastOnce: false,
  hasShownOptionHoldAtLeastOnce: false,
  isInLayer: false,
  isJoyview: false,
  isOverrideSticky: true,
  isTotalPrice: false,
  submitPriceRemoteForm: () => {},
};
type PriceRemoteContextAction = Partial<PriceRemoteContextValuesType>;

const criteriaContextReducer = (state, action: PriceRemoteContextAction) => {
  return { ...state, ...action };
};

type PriceRemoteContextType = [
  PriceRemoteContextValuesType,
  (arg0: PriceRemoteContextAction) => void,
];
export const PriceRemoteContext = createContext<PriceRemoteContextType>([initialState, () => {}]);
export const PriceRemoteContextProvider = ({
  children,
  value = {},
}: {
  children: React.ReactNode;
  value?: Partial<PriceRemoteContextValuesType>;
}) => {
  const [state, dispatch] = useReducer(criteriaContextReducer, { ...initialState, ...value });
  const reducer = useMemo((): PriceRemoteContextType => [state, dispatch], [state, dispatch]);
  return <PriceRemoteContext.Provider value={reducer}>{children}</PriceRemoteContext.Provider>;
};
